/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Dialog, DialogContent } from '@mui/material';
import { DialogTitleClose } from 'components/common/Dialogs/DialogTitleClose';
import { useState } from 'react';
import { Unauthorized } from '../Unauthorized/Unauthorized';

interface UnauthorizedDialogProps {
  redirectUrl: string;
}

const UnauthorizedDialog = (props: UnauthorizedDialogProps) => {
  const [open, setOpen] = useState(true);

  const handleOnClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleOnClose}>
      <DialogTitleClose title="Unauthorized Access" onClose={handleOnClose} />
      <DialogContent>
        <Unauthorized redirectUrl={props.redirectUrl} />
      </DialogContent>
    </Dialog>
  );
};

export default UnauthorizedDialog;
